<script lang="ts">
import { defineComponent, PropType } from 'vue'
import InputFormKana from '@/components/form/InputFormKana.vue'
import InputFormKanji from '@/components/lead/InputFormKanji.vue'

export default defineComponent({
  name: 'InputProfileName',

  components: {
    InputFormKana,
    InputFormKanji,
  },

  props: {
    namespace: {
      type: String,
      default: '',
    },

    userLeadInfo: {
      type: Object as PropType<UserLeadInfo>,
      required: true,
    },
  },

  emits: [
    'update:lastName',
    'update:firstName',
    'update:lastNameKana',
    'update:firstNameKana',
    'error'
  ],
})
</script>

<template>
  <div class="l-rows">
    <!-- 氏名 -->
    <div
      v-if="userLeadInfo.lastName || userLeadInfo.firstName"
      class="l-rows--row">
      <div class="l-cols is-col2">
        <!-- 姓 -->
        <div
          v-if="userLeadInfo.lastName && userLeadInfo.lastNameKana"
          class="l-cols--col">
          <InputFormKanji
            :model-value="userLeadInfo.lastName.value"
            :model-value-kana="userLeadInfo.lastNameKana.value"
            :name="userLeadInfo.lastName.name"
            :namespace="namespace"
            header="姓"
            placeholder="例：田中"
            autocomplete="family-name"
            :validation-scheme="userLeadInfo.lastName.validationScheme"
            @update:model-value="$emit('update:lastName', $event)"
            @update:model-value-kana="$emit('update:lastNameKana', $event)"
            @error="$emit('error', $event)" />
        <!-- /.l-cols col --></div>

        <!-- 名 -->
        <div
          v-if="userLeadInfo.firstName && userLeadInfo.firstNameKana"
          class="l-cols--col">
          <InputFormKanji
            :model-value="userLeadInfo.firstName.value"
            :model-value-kana="userLeadInfo.firstNameKana.value"
            :name="userLeadInfo.firstName.name"
            :namespace="namespace"
            header="名"
            placeholder="例：太郎"
            autocomplete="given-name"
            :validation-scheme="userLeadInfo.firstName.validationScheme"
            @update:model-value="$emit('update:firstName', $event)"
            @update:model-value-kana="$emit('update:firstNameKana', $event)"
            @error="$emit('error', $event)" />
        <!-- /.l-cols col --></div>
      <!-- /.l-cols --></div>
    <!-- /.l-rows row --></div>

    <!-- 氏名（かな） -->
    <div
      v-if="userLeadInfo.lastNameKana || userLeadInfo.firstNameKana"
      class="l-rows--row">
      <div class="l-cols is-col2">
        <!-- 姓（かな） -->
        <div
          v-if="userLeadInfo.lastNameKana"
          class="l-cols--col">
          <InputFormKana
            :model-value="userLeadInfo.lastNameKana.value"
            :namespace="namespace"
            :name="userLeadInfo.lastNameKana.name"
            header="姓（かな）"
            placeholder="例：たなか"
            :has-trim="true"
            :validation-scheme="userLeadInfo.lastNameKana.validationScheme"
            @update:model-value="$emit('update:lastNameKana', $event)"
            @error="$emit('error', $event)" />
        <!-- /.l-cols col --></div>

        <!-- 名（かな） -->
        <div
          v-if="userLeadInfo.firstNameKana"
          class="l-cols--col">
          <InputFormKana
            :model-value="userLeadInfo.firstNameKana.value"
            :namespace="namespace"
            :name="userLeadInfo.firstNameKana.name"
            header="名（かな）"
            placeholder="例：たろう"
            :has-trim="true"
            :validation-scheme="userLeadInfo.firstNameKana.validationScheme"
            @update:model-value="$emit('update:firstNameKana', $event)"
            @error="$emit('error', $event)" />
        <!-- /.l-cols col --></div>
      <!-- /.l-cols --></div>
    <!-- /.l-rows row --></div>
  <!-- /.l-rows --></div>
</template>
